import React from 'react';

const formatLabel = (value) => {
  if (!value) return '';
  return value
    .split(/\s+/)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

const LinkRenderer = ({ block }) => {
  const items = Array.isArray(block.items) ? block.items : [];

  return (
    <div className="my-6">
      {(block.title || block.description) && (
        <div className="mb-4">
          {block.title && <h3 className="text-xl font-semibold text-slate-800">{block.title}</h3>}
          {block.description && (
            <p className="text-sm text-slate-600 mt-1">{block.description}</p>
          )}
        </div>
      )}
      <div className="grid gap-4 sm:grid-cols-2">
        {items.length === 0 ? (
          <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 p-6 text-center text-sm text-slate-500">
            Add links with details like software, page info, or platform notes.
          </div>
        ) : (
          items.map((item, index) => (
            <a
              key={`${block.id || 'link'}-${index}`}
              href={item.url || '#'}
              target="_blank"
              rel="noreferrer"
              className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm transition hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <div className="block text-base font-semibold text-slate-800 hover:text-blue-600 break-words">
                    {item.title || item.url || 'Untitled link'}
                  </div>
                  {item.url && (
                    <p className="text-xs text-slate-500 break-all mt-1">{item.url}</p>
                  )}
                </div>
                {item.category && (
                  <span className="shrink-0 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-600">
                    {formatLabel(item.category)}
                  </span>
                )}
              </div>
              {item.description && (
                <p className="mt-3 text-sm text-slate-600">{item.description}</p>
              )}
              <div className="mt-3 space-y-1 text-xs text-slate-500">
                {item.platform && (
                  <div>
                    <span className="font-semibold text-slate-600">Software/Platform:</span> {item.platform}
                  </div>
                )}
                {item.pageInfo && (
                  <div>
                    <span className="font-semibold text-slate-600">Page Info:</span> {item.pageInfo}
                  </div>
                )}
                {item.notes && (
                  <div>
                    <span className="font-semibold text-slate-600">Notes:</span> {item.notes}
                  </div>
                )}
                {item.tags && (
                  <div>
                    <span className="font-semibold text-slate-600">Tags:</span> {item.tags}
                  </div>
                )}
              </div>
            </a>
          ))
        )}
      </div>
    </div>
  );
};

export default LinkRenderer;
